module.exports = __webpack_public_path__ + "static/media/code-example.593998ef.svg";